import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import html2canvas from "@html2canvas/html2canvas";
import {DateUtil} from "../../../utils/dateUtil";
import {NumberUtil} from "../../../utils/number-util";
import {APIURL} from "../../../config/config";
import axios from "axios";

// import {APIURL} from "../../../config/config";
// import axios from "axios";
// import PreviewImage from '../../../views/PreviewImage/';
// import {Modal, ModalBody} from "reactstrap";

// const port = window.env.PORT;

export  default class CarQuotation extends Component {

  constructor (props) {
    super(props)
    this.printRef = React.createRef();
    //this.handleOnSubmitCustomer.bind(this);
    this.state = {
      lists: [],
      load_data: true,
      danger: false,
      car_id: 0,
      action: 'บันทึก',
      car: this.props.car,
      real_sell_price: 0,
      down_payment: 0,
      interest: 0,
      period: 0,
      car_net_profit: 0,
      car_sale_price: 0,
      percent_down: 0,
      yord_jud: 0,
      yord_jud_interest: 0,
      month_payment: 0,
      month_payment_vat: 0,
      installment_balance_zero:0,
      preview_image_url: '',
      preview_image_select: false,
      interest_topup : 0,
      interest_new : 0,

      total_out_car : 0,
      insurance : 0,
      transfer_fee : 0,
      insurance_floor: '',
      name_customer : '',
      car_sell_type: 'จัดไฟแนนซ์',
      logoBase64Img: '',
      company_setting: null,
      quo_note: '',
      is_printable_note: false,
    }

    this.togglePreviewImage = this.togglePreviewImage.bind(this)
    this.onPreviewSelected = this.onPreviewSelected.bind(this)
    this.handleDownloadImage = this.handleDownloadImage.bind(this)
    this.calculateCarQuo = this.calculateCarQuo.bind(this)
    this.onCarSellTypeBuyChanged = this.onCarSellTypeBuyChanged.bind(this)
    this.loadCompanySetting = this.loadCompanySetting.bind(this);
    this.loadCompanyLogoBase64 = this.loadCompanyLogoBase64.bind(this);
    this.handleNoteChange = this.handleNoteChange.bind(this);
  }

  loadCompanyLogoBase64() {
    let uri =  APIURL + '/company_setting/logoimage/1';
    axios.get(uri)
        .then(res => {
          let body = res.data.body
          this.setState({ logoBase64Img: body })
        }).catch(error => {
      console.log('error:', error)
    })
  }

  loadCompanySetting() {
    axios.get(APIURL + '/company_setting/1').then(res => {
      let data = res.data
      let company_setting = data.company_setting
      this.setState({
        company_name: company_setting.company_name,
        company_tel: company_setting.company_tel
      })
    })
  }

  handleNoteChange(event){
    this.setState({ quo_note: event.target.value });
  }

  componentDidMount () {
    this.loadCompanyLogoBase64();
    this.loadCompanySetting();
    this.setState({car_sale_price: this.state.car.car_sale_price})
  }

  onPreviewSelected(url){
    this.setState({
      preview_image_url: url,
      preview_image_select: true
    });
  }

  togglePreviewImage() {
    this.setState({
      preview_image_select: !this.state.preview_image_select
    });
  }

  async handleDownloadImage () {
    const element = this.printRef.current;
    //console.log(element)
    //const canvas = await html2canvas(element);

    const canvas = await html2canvas(element, {
      // Optional: Add options for html2canvas for better capture
      scale: 2, // Increase scale for better resolution
      useCORS: true // Use if your element contains images from other origins
      // ... other options
    });

    const data = canvas.toDataURL('image/jpg');
    const link = document.createElement('a');

    if (typeof link.download === 'string') {
      link.href = data;
      link.download = 'ใบเสนอราคา.jpg';

      document.body.appendChild(link);
      link.click();
      setTimeout(()=>{
        this.setState({
          is_printable_note: false
        })
      }, 2000)
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  }

  onCarSellTypeBuyChanged(e){
    let car_sell_type = e.currentTarget.value
    this.setState({
      car_sell_type: car_sell_type
    },()=>{
      this.calculateCarQuo();
    });
  }

  calculateCarQuo(){
    let car_sale_price = Number(this.state.car_sale_price); // ราคาขาย
    let yord_jud = Number(this.state.yord_jud); // ยอดจัดไฟแนนซ์
    let down_payment = Number(this.state.down_payment); // ดาวน์
    let insurance = Number(this.state.insurance); // ประกันรถ
    let transfer_fee = Number(this.state.transfer_fee); // ค่าจัดโอน / ย้าย

    if(yord_jud > 0){
      let car_quo_amount = down_payment + transfer_fee + insurance;
      let total_out_car = Number(car_quo_amount);

      this.setState({
        car_quo_amount : car_quo_amount,
        total_out_car: total_out_car
      });
    }else if (yord_jud === 0 && down_payment === 0 && insurance === 0 && transfer_fee === 0){
      let car_quo_remain = car_sale_price;
      let total_out_car = Number(car_quo_remain);

      this.setState({
        total_out_car: total_out_car
      });
    }else {
      // ราคาเงินสด
      let car_quo_remain = car_sale_price;
      // รวมเงินจ่าย
      let car_quo_amount = down_payment + transfer_fee + insurance;
      let total_out_car = car_quo_remain + Number(car_quo_amount);

      this.setState({
        car_quo_amount: car_quo_amount,
        total_out_car: total_out_car
      });
    }

  }

  render () {

    let car_license_plate = this.state.car.car_license_plate_new === '' ?  this.state.car.car_license_plate_old : this.state.car.car_license_plate_new
    let province_name = this.state.car.car_license_plate_new !== '' &&  this.state.car.car_license_plate_new !==  this.state.car.car_license_plate_old ? this.state.car.province_name_new : this.state.car.province_name_old
    let car_date_regis_text = this.state.car.car_date_regis === '' || this.state.car.car_date_regis === null || this.state.car.car_date_regis === '0000-00-00' ? 'ไม่ระบุ' : DateUtil.convertLongDateThai(this.state.car.car_date_regis)
    let car_miles = this.state.car.car_miles === '' || this.state.car.car_miles === '0' ? 'ไม่ระบุ' :  NumberUtil.addCommasZeroInt(this.state.car.car_miles)
    let car_size_engine = this.state.car.car_size_engine === '' || this.state.car.car_size_engine === null ? 'ไม่ระบุ' :  this.state.car.car_size_engine
    let logo = this.state.logoBase64Img
    let logoWidth = 100
    return (
      <>
        <div
          className="card card-accent-info" ref={this.printRef}
        >
          <form action="" method="post">
            <div className="card-header text-center">
              <h6><strong className="text-title">ใบเสนอราคา</strong></h6>
            </div>

            <div className="card-block">
              <div className="text-center">
                <img src={logo} width={logoWidth} alt="logo"/>
                <br/>
                <h6><strong className="text-title">{this.state.company_name}</strong></h6>
              </div>
              <br/>
                  <div className="row text-center">
                    <div className="pl-3 col-12 mb-1">
                      <strong className="text-primary font-weight-bold">ยี่ห้อรถยนต์ &nbsp;{this.state.car.car_brand_name} &nbsp;{this.state.car.car_model_name} &nbsp;รุ่นย่อย {this.state.car.car_sub_model_name}
                      &nbsp;{this.state.car.car_gear_name} &nbsp;ปีผลิต {this.state.car.car_year_name} &nbsp;สี {this.state.car.car_color_name} </strong>
                    </div>
                    <div className="pl-3 col-12 mb-1">
                      <strong className="text-primary font-weight-bold">จดทะเบียน {car_date_regis_text} &nbsp;เครื่อง {car_size_engine}
                        &nbsp;เลขไมล์ {car_miles} กิโลเมตร</strong>
                    </div>
              <div className="pl-3 col-12">
                <strong className="text-primary font-weight-bold">ทะเบียนรถ ( {car_license_plate}&nbsp;จ. {province_name} )</strong>
            </div>

                  </div>

                  <div className="row">
                    <div>
                      <label className="radio-inline ml-3 mt-4" htmlFor="refund_type1">
                        <input type="radio"
                               name="car_sell_type"
                               value="จัดไฟแนนซ์"
                               defaultChecked={this.state.car_sell_type === 'จัดไฟแนนซ์'}
                               className="btn btn-primary"
                               onChange={this.onCarSellTypeBuyChanged}
                        /> &nbsp; จัดไฟแนนซ์
                      </label>
                      &nbsp;&nbsp;&nbsp;
                      <label className="radio-inline ml-3 mt-4" htmlFor="refund_type2">
                        <input type="radio"
                               name="car_sell_type"
                               value="เงินสด"
                               defaultChecked={this.state.car_sell_type === 'เงินสด'}
                               className="btn btn-primary"
                               onChange={this.onCarSellTypeBuyChanged}
                        /> &nbsp; เงินสด
                      </label>
                    </div>

                    <div className="row ml-4">
                      <div className="form-group col-sm-4">
                        <strong>ชื่อลูกค้า :</strong>
                      </div>

                      <div className="form-group col-sm-7">
                        <input type="text"
                               className="form-control font-weight-bold"
                               ref={this.state.name_customer}
                               onChange={()=>{}}
                        />
                      </div>

                      <div className="form-group col-sm-4">
                        <strong>ราคารถยนต์ :</strong>
                      </div>
                      <div className="form-group col-sm-7">
                        <input type="text"
                               ref="real_sell_price"
                               value={this.state.car_sale_price}
                               className="hidden"
                               onChange={()=>{}}
                        />
                        <NumberFormat
                            className="form-control text-success font-weight-bold"
                            thousandSeparator={true}
                            //prefix={'฿'}
                            //placeholder="กรอกค่าโอน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.car_sale_price}
                            onValueChange={(event) => {
                              const {value} = event
                              this.setState({car_sale_price: value}, () => this.calculateCarQuo())

                            }}
                        />
                      </div>

                      <div className="form-group col-sm-4">
                        <strong>ยอดจัดไฟแนนซ์ :</strong>
                      </div>
                      <div className="form-group col-sm-7">
                        <input type="text"
                               name="yord_jud"
                               className="hidden form-control text-danger font-weight-bold"
                               onChange={()=>{}}
                        />
                          <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              //prefix={'฿'}
                              //decimalScale={2}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.yord_jud}
                              disabled={this.state.car_sell_type === 'เงินสด'}
                              onValueChange={(event) => {
                                const {value} = event
                                this.setState({yord_jud: value}, () => this.calculateCarQuo())

                              }}
                          />
                      </div>

                      <div className="form-group col-sm-4">
                        <strong>เงินดาวน์ :</strong>
                      </div>
                      <div className="form-group col-sm-7">
                        <input type="text"
                               name="down_payment"
                               className="hidden form-control text-danger font-weight-bold"
                               onChange={()=>{}}
                        />
                        <NumberFormat
                            className="form-control"
                            thousandSeparator={true}
                            //prefix={'฿'}
                            //placeholder="กรอกค่าโอน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.down_payment}
                            disabled={this.state.car_sell_type === 'เงินสด'}
                            onValueChange={(event) => {
                              const {value} = event
                              this.setState({down_payment: value}, () => this.calculateCarQuo())

                            }}
                        />
                      </div>
                      {/*<div className="form-group col-sm-3">
                        <NumberFormat
                            className="form-control"
                            thousandSeparator={true}
                            //prefix={'฿'}
                            //placeholder="กรอกค่าโอน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.down_payment}
                        />
                      </div>*/}

                      <div className="form-group col-sm-4">
                        <strong>ประกันรถยนต์ :</strong>
                      </div>
                      <div className="form-group col-sm-7">
                        <input type="text"
                               name="insurance_floor"
                               className="hidden form-control text-danger font-weight-bold"
                               onChange={()=>{}}
                        />
                        <NumberFormat
                            className="form-control"
                            thousandSeparator={true}
                            //prefix={'฿'}
                            //placeholder="กรอกค่าโอน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.insurance}
                            onValueChange={(event) => {
                              const {value} = event
                              this.setState({insurance: value}, () => this.calculateCarQuo())

                            }}
                        />
                      </div>

                      <div className="form-group col-sm-4">
                        <strong>ค่าจัดโอน / ย้าย :</strong>
                      </div>
                      <div className="form-group col-sm-7">
                        <input type="text"
                               name="transfer_fee"
                               className="hidden form-control text-danger font-weight-bold"
                               onChange={()=>{}}
                        />
                        <NumberFormat
                            className="form-control"
                            thousandSeparator={true}
                            //prefix={'฿'}
                            //placeholder="กรอกค่าโอน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.transfer_fee}
                            onValueChange={(event) => {
                              const {value} = event
                              this.setState({transfer_fee: value}, () => this.calculateCarQuo())

                            }}
                        />
                      </div>

                      <div className="form-group col-sm-4 mt-0">
                        <strong>รวมออกรถ :</strong>
                      </div>
                      <div className="form-group col-sm-7">
                        <NumberFormat
                            className="form-control text-danger font-weight-bold"
                            thousandSeparator={true}
                            displayType={'input'}
                           // prefix={'฿'}
                            decimalScale={2}
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.total_out_car}
                        />
                      </div>


                      <div className="form-group col-sm-4">
                        <strong>ค่างวด 60 :</strong>
                      </div>

                      <div className="form-group col-sm-7">
                        {/*<input type="text"
                               name="period_1"
                               placeholder="ค่างวด/เดือน"
                               className="form-control text-danger font-weight-bold"
                               onChange={()=>{}}
                        />*/}
                        <NumberFormat
                            name="period_1"
                            className="form-control text-primary font-weight-bold"
                            thousandSeparator={true}
                            placeholder="ค่างวด/เดือน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            onValueChange={()=>{}}
                        />
                      </div>

                      <div className="form-group col-sm-4">
                        <strong>ค่างวด 72 :</strong>
                      </div>

                      <div className="form-group col-sm-7">
                        <NumberFormat
                            name="period_2"
                            className="form-control text-primary font-weight-bold"
                            thousandSeparator={true}
                            placeholder="ค่างวด/เดือน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            onValueChange={()=>{}}
                        />
                      </div>

                      <div className="form-group col-sm-4">
                        <strong>ค่างวด 84 :</strong>
                      </div>

                      <div className="form-group col-sm-7">
                        <NumberFormat
                            name="period_3"
                            className="form-control text-primary font-weight-bold"
                            thousandSeparator={true}
                            placeholder="ค่างวด/เดือน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            onValueChange={()=>{}}
                        />
                      </div>

                      <div className="form-group col-sm-4">
                        <strong>จัดไฟแนนซ์ธนาคาร :</strong>
                      </div>

                      <div className="form-group col-sm-7">
                        <textarea rows={2}
                               name="finance_bank"
                               className="form-control font-weight-bold"
                               onChange={()=>{}}
                        />
                      </div>

                      <div className="form-group col-sm-4">
                        <strong>หมายเหตุ :</strong>
                      </div>

                      <div className="form-group col-sm-7">
                        {this.state.is_printable_note === false &&
                        <textarea rows={3}
                               className="form-control text-danger font-weight-bold"
                               name="quo_note"
                               value={this.state.quo_note}
                               onChange={(e)=>{
                                 this.handleNoteChange(e)
                               }}
                        />
                        }

                        {this.state.is_printable_note === true &&
                        <div
                             style={{
                               whiteSpace: 'pre-wrap', // Preserve whitespace and line breaks
                               wordBreak: 'break-word', // Break long words
                               display: 'block', // Initially hidden
                               // Add other styling to match your desired output appearance (font, size, color, padding, etc.)
                               color: 'red',
                               fontWeight: 'bold',
                               minHeight: '0em', // Ensure it has enough height if the text is short
                               lineHeight: '1.4',
                             }}>
                          {this.state.quo_note}
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
          </form>
        </div>

        <div>
          <button className="float-right mb-5 btn btn-secondary"
                  type="button"

                  onClick={()=>{
                    this.setState({
                      is_printable_note : true
                    },()=>{
                      this.handleDownloadImage()
                    })
                  }}
          >
            ดาวน์โหลดใบเสนอราคา.jpg
          </button>
        </div>
      </>
    )
  }
}
